export const RouteNames = {
  login: "/login",
  accounts: "/accounts",
  activityLogs: "/activity-logs",
};
